import React from 'react';
import { FiUsers } from 'react-icons/fi';

function ProjectCard({ project, onClick }) {
  const handleClick = () => onClick(project);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(project);
    }
  };

  return (
    <div
      className="project-card"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{ cursor: 'pointer' }}
      role="button"
      tabIndex={0}
    >
      <div className="project-card-header">
        <h3>{project.name}</h3>
        <span className={`project-status ${project.status}`}>
          {project.status}
        </span>
      </div>
      <p className="project-description">{project.description}</p>

      {/* Team Members Section */}
      <div className="project-team-info">
        <div className="team-header">
          <span className="label"><FiUsers /> Team Members</span>
          <span className="count">{project.members?.length || 0}</span>
        </div>
        <div className="team-members-list">
          {project.members && project.members.length > 0 ? (
            project.members.slice(0, 3).map((member) => (
              <div key={member._id} className="team-member-item">
                {member.profilePicture ? (
                  <img src={member.profilePicture} alt={member.firstName} className="team-member-avatar-img" />
                ) : (
                  <div className="team-member-avatar">
                    {member.firstName?.[0]}{member.lastName?.[0]}
                  </div>
                )}
                <span className="team-member-name">
                  {member.firstName} {member.lastName}
                </span>
              </div>
            ))
          ) : (
            <p className="no-members">No team members assigned</p>
          )}
          {project.members?.length > 3 && (
            <div className="more-members">
              +{project.members.length - 3} more
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(ProjectCard);
